import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IHttpResult, interfaces } from '@leandredev/dcbm-common-lib';
import * as dcbm from '@leandredev/dcbm-ng-lib';
import { IHttpOption } from '@leandredev/dcbm-ng-lib';
import { Observable } from 'rxjs';

@Injectable()
export class FileUploadService implements Partial<dcbm.service.FileUploadService> {
  private service: dcbm.service.FileUploadService;

  constructor(private http: HttpClient) {
    this.service = new dcbm.service.FileUploadService(this.http, true);
  }

  upload<T extends interfaces.IFile, U extends interfaces.IFile>(body: U, query: object, options?: IHttpOption): Observable<IHttpResult<T>> {
    return this.service.upload(body, query, options);
  }
}
